<template>
  <v-img
    alt="Jamesway Logo"
    :contain="contain"
    :src="
      useMini
        ? miniCompanyImage
        : useDark
        ? darkCompanyImage
        : lightCompanyImage
    "
    transition="scroll-y-transition"
    :size="size"
    :width="size ? size : useMini ? 45 : 100"
    :height="size"
  />
</template>

<script>
import { get } from 'vuex-pathify';
export default {
  name: 'BaseVuetifyLogo',
  computed: {
    miniCompanyImage: get('app/miniCompanyImage'),
    darkCompanyImage: get('app/darkCompanyImage'),
    lightCompanyImage: get('app/lightCompanyImage')
  },
  props: {
    route: {
      type: String,
      default: 'Home'
    },
    size: {
      type: [String, Number],
      default: null
    },
    useDark: {
      type: Boolean,
      default: false
    },
    contain: {
      type: Boolean,
      default: false
    },
    useMini: {
      type: Boolean,
      default: false
    }
  }
};
</script>
